export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.30c47935.woff";